// declare const qz: any;
import qz from "qz-tray";
import { AppDispatch } from "../../../store/store";
import {
  setConnectionState,
  setClientVersion,
} from "../../../store/slices/qztray/qzTrayClientSlice";

/**
 * 🔍 verifyClientConnection
 * ------------------------------------------------------------
 * Verifica si el cliente QZ Tray está realmente activo y responde.
 * Si responde con versión, marca el estado como conectado.
 * Si falla, lo marca como desconectado.
 */
export const verifyClientConnection = async (
  dispatch: AppDispatch,
  showAlert: (type: string, title: string, msg: string) => void
) => {
  try {
    // console.log("🔎 Verificando conexión QZ Tray...");

    const version = await qz.api.getVersion();

    if (version) {
      dispatch(setConnectionState({ isConnected: true }));
      dispatch(setClientVersion(version));
      // console.log("✅ Cliente QZ activo. Versión:", version);
      showAlert("success", "QZ Tray", `Conectado (v${version})`);
      return true;
    }

    throw new Error("QZ Tray no respondió correctamente.");
  } catch (err: any) {
    console.warn("⚠️ Verificación fallida:", err?.message);
    dispatch(setConnectionState({ isConnected: false }));
    dispatch(setClientVersion(null));
    showAlert("warning", "Cliente QZ inactivo", "No se pudo verificar la conexión.");
    return false;
  }
};
